import { DropboxFolderType, DropboxToken } from '@account/types';
import { api } from '@services/api';

const dropboxApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getDropboxAuthorizationUrl: builder.query<
            { type: DropboxFolderType; url: string },
            { type: DropboxFolderType }
        >({
            query: (params) => ({ url: `dropbox/auth-link/`, params }),
            providesTags: ['DropboxAuthorizationUrl'],
        }),
        getDropboxTokens: builder.query<{ count: number; results: DropboxToken[] }, void>({
            query: () => 'dropbox/token/',
            providesTags: ['DropboxTokens'],
        }),
        createDropboxToken: builder.mutation<DropboxToken, { code: string; type: DropboxFolderType }>({
            query: (body) => ({
                url: 'dropbox/token/',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['DropboxTokens'],
        }),
        deleteDropboxToken: builder.mutation<{ deleted_count: number }, { id: number }>({
            query: (body) => ({
                url: `dropbox/token/`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['DropboxTokens'],
        }),
    }),
});

export const {
    useGetDropboxAuthorizationUrlQuery,
    useGetDropboxTokensQuery,
    useCreateDropboxTokenMutation,
    useDeleteDropboxTokenMutation,
} = dropboxApi;
export default dropboxApi;
